import React from 'react'
import PropTypes from 'prop-types'
import { CheckBox } from '.'
import { LoadingIndicator } from 'components/loading'
import { Label } from 'reactstrap'
import { isNotNull } from 'utils/isNotNull'

const MultiCheckBox = (props) => {
  const { loading, checkedIds, items, color, onChange, disabled } = props
  if (loading) { return <LoadingIndicator />}

  const handleChecked = (checked, id) => checked ? onChange([...checkedIds, id]) : onChange(checkedIds.filter(x => x !== id))
  const contains = (id) => isNotNull(checkedIds.find(x => x === id))
  const renderCheckbox = ({ item, idx }) => {
    return (
      <div key={idx}>
        <CheckBox disabled={disabled} color={color} checked={contains(item.id)} onChange={checked => handleChecked(checked, item.id)} />
        <Label>{item.name}</Label>
      </div>
    )
  }
  if (items) {
    return items.map((item, idx) => renderCheckbox({ item, idx }))
  }
  return null
}

MultiCheckBox.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  checkedIds: PropTypes.array,
  items: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
MultiCheckBox.defaultProps = {
  color: 'primary',
  disabled: false,
  checkedIds: [],
  onChange: (checkedIds) => {} 
}

export default MultiCheckBox
